/* eslint-disable max-len */
import {defineMessages} from 'react-intl';

export default defineMessages({
	title: {
		id: 'popups.returnOrder.title',
		defaultMessage: 'Return authorization',
	},
	description1: {
		id: 'popups.returnOrderLogin.description1',
		defaultMessage:
			"If you are a registered user, you can login to request a return in the 'Orders' section of your account.",
	},
	description2: {
		id: 'popups.returnOrderLogin.description2',
		defaultMessage:
			'Start the return process by entering the order number and email used to place the order.',
	},
	description3: {
		id: 'popups.returnOrderLogin.description3',
		defaultMessage:
			'<h4>Note</h4>: a Return Authorization can only be issued once a tracking number has become available. for immediate service please contact our customer service.',
	},
	mandatoryFields: {
		id: 'popups.returnOrderLogin.mandatoryFields',
		defaultMessage: 'Fields with an asterisk (*) must be filled in.',
	},
	loginButton: {
		id: 'popups.returnOrderLogin.loginButton',
		defaultMessage: 'Login',
	},
	orderNoPlaceholder: {
		id: 'popups.returnOrderLogin.orderNoPlaceholder',
		defaultMessage: 'Order number*',
	},
	emailPlaceholder: {
		id: 'popups.returnOrderLogin.emailPlaceholder',
		defaultMessage: 'Email*',
	},
	submitButton: {
		id: 'popups.returnOrderLogin.submitButton',
		defaultMessage: 'Apply',
	},
	orderError: {
		id: 'popups.returnOrderLogin.orderError',
		defaultMessage: 'Order not found',
	},
	orderNotEligible: {
		id: 'popups.returnOrderLogin.orderNotEligible',
		defaultMessage: 'Order is not eligible for return',
	},
	orderRequiredError: {
		id: 'popups.returnOrderLogin.orderRequiredError',
		defaultMessage: 'Order number is required',
	},
	emailRequiredError: {
		id: 'popups.returnOrderLogin.emailRequiredError',
		defaultMessage: 'Email is required',
	},
	emailInvalidError: {
		id: 'popups.returnOrderLogin.emailInvalidError',
		defaultMessage: 'Please enter a valid email address',
	},
});
